import { render, staticRenderFns } from "./MonthCalendar.vue?vue&type=template&id=22125e62&"
import script from "./MonthCalendar.vue?vue&type=script&lang=js&"
export * from "./MonthCalendar.vue?vue&type=script&lang=js&"
import style0 from "./MonthCalendar.vue?vue&type=style&index=0&id=22125e62&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports